const dateFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' });

const formatDate = (isoString) => {
	if (!isoString) return null;
	const date = new Date(isoString);
	if (Number.isNaN(date.getTime())) return null;
	return dateFormatter.format(date);
};

export default formatDate;
